import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { TestimonialMultipleColumn as TestimonialMultipleColumnZDS, } from '@zapier/design-system';
import { RichText } from '../RichText';
export function TestimonialMultipleColumn(props) {
    return (_jsx(TestimonialMultipleColumnZDS, { backgroundColor: props.backgroundColor, numberOfColumns: props.numberOfColumns, testimonials: props.testimonials.map((testimonial) => {
            return Object.assign(Object.assign({}, testimonial), { quote: (_jsx(RichText, { backgroundColor: props.backgroundColor, html: testimonial.quote })) });
        }) }));
}
//# sourceMappingURL=TestimonialMultipleColumn.js.map